import SideMenu from './SideMenu.vue';

export default SideMenu;
